const nutritionPageTranslations = {
  intro: {
    title: "Enjoy Your \n Delicous Meals",
    description:
      "Feel free to choose from vast options of different meals recipes all tailored to your macros needs.",
  },
  mealOptions: {
    title: "Choose One Option.",
  },
  mealsSlots: {
    title: "Select Meal Slot.",
  },
  ingredientsPopUp: {
    title: "Ingredients",
    close: "Close",
  },
};

export default nutritionPageTranslations;
